import { parseISO, format } from "date-fns";

// Function to format a date string in "dd-MM-yyyy" format
export const formatDate = (dateString: string | null) => {
  if (!dateString) return ""; // Return an empty string or handle it as needed

  const dateTimeObject = parseISO(dateString);

  if (isNaN(dateTimeObject.getTime())) {
    // Handle invalid date (parseISO returns Invalid Date)
    return ""; // Return an empty string or handle it as needed
  }

  // return format(dateObject, "dd-MM-yyyy");
  return format(dateTimeObject, "dd-MMM-yyyy hh:mma");

};
    export const formatDateOnly = (dateString: string | null) => {
      if (!dateString) return ""; // Return an empty string or handle it as needed

      const dateTimeObject = parseISO(dateString);

      if (isNaN(dateTimeObject.getTime())) {
        // Handle invalid date (parseISO returns Invalid Date)
        return ""; // Return an empty string or handle it as needed
      }

      // return format(dateObject, "dd-MM-yyyy");
      return format(dateTimeObject, "dd-MMM-yyyy");

    };

export function convertDate(dateString: string | null) {
  if (!dateString) return "";
  const p = dateString.split(/\D/g);
  return [p[0], p[1], p[2]].join("-");
}

function NewformatTime(timeProp: any) {
  if (timeProp === null || typeof timeProp !== "string") {
    // Handle null or invalid input
    console.error("Invalid timeProp:", timeProp);
    return null; // or throw an error, or return a default value
  }
  const myTime = (timeProp && timeProp?.slice(0, -2)) || "";
  const [hour, minute] = myTime?.split(/[: ]/) || [];
  let hourValue = parseInt(hour, 10);
  const checkFormat = /pm/i.test(timeProp || "");

  // Adjust hourValue based on PM format
  if (checkFormat && hourValue !== 12) {
    hourValue += 12;
  } else if (!checkFormat && hourValue === 12) {
    hourValue = 0; // Adjust for 12 AM (midnight)
  }

  const Time = `${hourValue?.toString()?.padStart(2, "0")}:${minute}`;
  return new Date(
    `Fri Mar 15 2024 ${Time && Time}:00 GMT+0100 (West Africa Standard Time)`
  );
}
export default NewformatTime;

export function ExtractDate(dateTimeString: any) {
  // Create a new Date object from the datetime string
  const dateTime = new Date(dateTimeString);

  // Extract the date components
  const year = dateTime.getFullYear();
  const month = dateTime.getMonth() + 1; // Months are zero-indexed, so add 1
  const day = dateTime.getDate();

  // Format the date as needed (e.g., MM/DD/YYYY)
  const formattedDate = `${month}/${day}/${year}`;

  return formattedDate;
}

export function isCurrentDateGreaterThan(targetDateString: any) {
  // Get the current date and time
  var currentDate = new Date();

  // Convert the target date string to a Date object
  var targetDate = new Date(targetDateString);

  // Compare the current date with the target date
  if (currentDate > targetDate) {
    return true;
  } else {
    return false;
  }
}


export const getEndDate = (): string => {
  const today = new Date();
  
  // Get individual date components
  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
  const day = today.getDate().toString().padStart(2, '0');

  // Format the date string as "YYYY-MM-DD"
  const formattedDate = `${year}-${month}-${day}`;
  
  return formattedDate;
};


export const getStartDate = (): string => {
  const today = new Date();

  // Set the date to 10 months ago
  today.setMonth(today.getMonth() - 4);

  // Get individual date components
  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based, so add 1
  const day = today.getDate().toString().padStart(2, '0');

  // Format the date string as "YYYY-MM-DD"
  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
};

export const  getStartDateAYearAgo = (): string => {
  const today = new Date();

  // Set the date to 10 months ago
  today.setMonth(today.getMonth() - 12);

  // Get individual date components
  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based, so add 1
  const day = today.getDate().toString().padStart(2, '0');

  // Format the date string as "YYYY-MM-DD"
  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
};

  export const formatAmount = (amount: number | string) =>
  `₦${Number(amount)?.toLocaleString()}`;

  const nthNumber = (number: number) => {
    if (number > 3 && number < 21) return "th";
    switch (number % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };
  
  export const getDate = () => {
    const date = new Date();
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' })
    const year = date.getFullYear();
    const fullDate = [`${day}${nthNumber(day)}`,` ${month},`, year].join(' ');
    return `${fullDate}`;
}
